module.exports = __webpack_public_path__ + "img/icon-website-expansion-content-box-bg.7730a94.svg";